export default "__VITE_ASSET__Dw2JtWc3__"